


















import VueOptions from '@utils/VueOptions'

settings =
  name: 'WizardNavigation'
  
  vue:
    props: ['wizard']

    computed:
      routes: -> @wizard.wizardRoutes
      flatRoutes: -> @routes.reduce(((acc, item) -> [...acc, ...item.steps]), [])
      primaryRoutes: -> @flatRoutes.filter((step) -> step.primary)

    methods:
      hiNavTo: (route) ->
        @wizard.save()
        @wizard.clearSelectedData()
        @wizard.navToStepName(route.name)

      isRouteActive: (route) ->
        return true if @wizard.activeStep.name is route.name
        activeRoute = @flatRoutes.find((item) => item.name is @wizard.activeStep.name)

        while activeRoute
          parentRoute = @flatRoutes.find((item) -> item.name is activeRoute.parent)
          return true if parentRoute?.name is route.name
          activeRoute = parentRoute

        false

export default VueOptions.vue settings
